import { render, staticRenderFns } from "./SeparatorSection.vue?vue&type=template&id=61601443&"
import script from "./SeparatorSection.vue?vue&type=script&lang=js&"
export * from "./SeparatorSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports